// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__HDAA0","header":"ClearentDisclaimer_header__25Z7S","inner":"ClearentDisclaimer_inner__2jGCX"};